import request from '@/api/request'

// 项目审核 查询申报负责人
export const applyList = (data) => {
    return request({
        url: '/apply-user/query',
        method: 'POST',
        params: data
    })
}
// 项目审核 查询参与者
export const participantsQuery = (data) => {
    return request({
        url: '/participants-user/query',
        method: 'POST',
        params: data
    })
}
// 项目审核 管理员页面查询信息
export const list = (data) => {
    return request({
        url: '/auditing-advice/query',
        method: 'POST',
        params: data
    })
}
// 项目审核 项目状态-3，-2，-1,0,1,2,3
export const warehouse = (data) => {
    return request({
        url: '/auditing-advice/backProject',
        method: 'GET',
        params: data
    })
}
// 项目审核 专家评审
export const saveCenterReview = (data) => {
    return request({
        url: '/center-review/doSubmitCenterReview',
        method: 'POST',
        params: data
    })
}
// 项目审核 评审专家显示项目信息
export const dataManagement = (data) => {
    return request({
        url: '/user/dataManagement',
        method: 'GET',
        params: data
    })
}
// 项目审核 入库接口
export const doStorage = (data) => {
    return request({
        url: '/auditing-advice/doStorage',
        method: 'POST',
        params: data
    })
}
// 项目审核 推荐人用户
export const queryRefereeUserInfo = (data) => {
    return request({
        url: '/referee-user/queryRefereeUserInfo',
        method: 'POST',
        params: data
    })
}
// 项目审核 
export const queryParticipantsUserInfo = (data) => {
    return request({
        url: '/participants-user/queryParticipantsUserInfo',
        method: 'POST',
        params: data
    })
}
// 项目审核 查看预期成果
export const queryResearchResultInfo = (data) => {
    return request({
        url: '/research-result/queryResearchResultInfo',
        method: 'POST',
        params: data
    })
}
// 项目审核 
export const queryExpertsAdviceInfo = (data) => {
    return request({
        url: '/experts-advice/queryExpertsAdviceInfo',
        method: 'POST',
        params: data
    })
}

// 项目审核 查看课题论证
export const queryProjectDemonstrationInfo = (data) => {
    return request({
        url: '/project-demonstration/queryProjectDemonstrationInfo',
        method: 'GET',
        params: data
    })
}
// 项目审核 查看所在单位意见 委员会审核
export const queryExpertsUserInfo = (data) => {
    return request({
        url: '/experts-user/queryExpertsUserInfo',
        method: 'GET',
        params: data
    })
}
// 项目审核 查询基本信息
export const projectId = (data) => {
    return request({
        url: '/project/query/id',
        method: 'POST',
        params: data
    })
}
// 项目审核 查看所在单位意见
export const queryCompanyAdviceInfo = (data) => {
    return request({
        url: '/company-advice/queryCompanyAdviceInfo',
        method: 'POST',
        params: data
    })
}
// 项目审核 查看推荐人意见
export const queryRefereeAdviceInfo = (data) => {
    return request({
        url: '/referee-advice/queryRefereeAdviceInfo',
        method: 'POST',
        params: data
    })
}
// 项目审核 根据用户ID查询领导专家信息
export const queryByExpertsUserByUserId = (data) => {
    return request({
        url: '/experts-user/queryByExpertsUserByUserId',
        method: 'GET',
        params: data
    })
}